/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StrategyWeight
 */
export interface StrategyWeight {
    /**
     * 
     * @type {string}
     * @memberof StrategyWeight
     */
    strategyGuid: string;
    /**
     * 
     * @type {number}
     * @memberof StrategyWeight
     */
    weight: number;
}

/**
 * Check if a given object implements the StrategyWeight interface.
 */
export function instanceOfStrategyWeight(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "strategyGuid" in value;
    isInstance = isInstance && "weight" in value;

    return isInstance;
}

export function StrategyWeightFromJSON(json: any): StrategyWeight {
    return StrategyWeightFromJSONTyped(json, false);
}

export function StrategyWeightFromJSONTyped(json: any, ignoreDiscriminator: boolean): StrategyWeight {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'strategyGuid': json['strategy_guid'],
        'weight': json['weight'],
    };
}

export function StrategyWeightToJSON(value?: StrategyWeight | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'strategy_guid': value.strategyGuid,
        'weight': value.weight,
    };
}

